import { memo } from 'react';
import {
  Box,
  Flex,
  Menu,
  MenuButton,
  MenuItemOption,
  MenuList,
  MenuOptionGroup,
  Text,
} from '@chakra-ui/react';

import CalculationIconV1 from '../../icons/assets/CalculationIconV1';
import InputIconV1 from '../../icons/assets/InputIconV1';
import BuilderModeSvgIcon from 'pages/BuilderModeV1/icons/BuilderModeSvgIcon';
import { BUILDER_MODE_V1_LAYOUT, BUILDER_MODE_V1_TOKENS } from 'pages/BuilderModeV1/constants';

import toolbarDropdownButtonStyles from './toolbarDropdownButtonStyles';

export interface IndicatorTypeDropdownProperties {
  indicatorType: string;
  onChange: (type: string) => void;
}

const IndicatorTypeDropdown = memo(
  ({ indicatorType, onChange }: IndicatorTypeDropdownProperties) => {
    const normalizedType = indicatorType?.toLowerCase() ?? 'input';
    const isCalculation = normalizedType === 'calculation';

    return (
      <Menu variant='secondary' isLazy>
        <MenuButton as={Box} sx={toolbarDropdownButtonStyles} aria-label='Indicator type'>
          <Flex align='center' gap='12px' flex='1' minW={0}>
            {isCalculation ? <CalculationIconV1 size={20} /> : <InputIconV1 size={20} />}
            <Text
              fontFamily={BUILDER_MODE_V1_LAYOUT.toolbarFontFamily}
              fontSize='14px'
              fontWeight='400'
              color={BUILDER_MODE_V1_TOKENS.textDark}
              lineHeight='normal'
              noOfLines={1}
            >
              {isCalculation ? 'Calculation' : 'Input'}
            </Text>
            <BuilderModeSvgIcon name='chevronDown' width={9} height={6} />
          </Flex>
        </MenuButton>
        <MenuList zIndex={16} borderRadius='10px' borderColor={BUILDER_MODE_V1_TOKENS.border}>
          <MenuOptionGroup value={normalizedType} onChange={(value) => onChange(String(value))}>
            <MenuItemOption
              value='calculation'
              bg={isCalculation ? BUILDER_MODE_V1_TOKENS.activeBg : 'transparent'}
            >
              <Flex align='center' gap={2}>
                <CalculationIconV1 size={16} />
                <Text fontSize='14px'>Calculation</Text>
              </Flex>
            </MenuItemOption>
            <MenuItemOption
              value='input'
              bg={normalizedType === 'input' ? BUILDER_MODE_V1_TOKENS.activeBg : 'transparent'}
            >
              <Flex align='center' gap={2}>
                <InputIconV1 size={16} />
                <Text fontSize='14px'>Input</Text>
              </Flex>
            </MenuItemOption>
          </MenuOptionGroup>
        </MenuList>
      </Menu>
    );
  },
);

IndicatorTypeDropdown.displayName = 'IndicatorTypeDropdown';

export default IndicatorTypeDropdown;
